import { Component } from 'react';
import Page from '../../containers/page';

import {
    Button,
    Col,
    Container,
    Modal,
    ModalBody,
    ModalFooter,
    Row,
} from 'reactstrap';

import { API_ENDPOINT } from '../../constants';
import { formValueSelector, change } from 'redux-form';  // ES6
import { connect } from 'react-redux';
import JournalTemplatesPage from '../journalTemplates/page';
import Checkbox from '../../components/forms/fields/checkbox';
import DoorQrDownload from './QRcodeClinicGenerate';
import { Player } from '@lottiefiles/react-lottie-player';

function parseText(response) {
    return response.text().then(text => {
        return {
            result: text,
            status: response.status
        }
    })
}
class JournalNotesPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ...props.initialData,
            params: {
                entries: 10,
                page: 0
            },
            tabIndex: 1,
            allowAdminUnlockSignedNotes: false,
            allowHealthcareProviderUnlockSignedNotes: false,
            sendEmailReminderIfThereAreUnsignedNotesOlderThenAWeek: false,
        };
    }

    getSettings = () => {
        fetch(`${API_ENDPOINT}/user/journal/settings/${this.props.selectedGroup}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('authToken')}`,
            },
        }).then(parseText).then(({ status, result }) => {
            if (status == 200) {
                const data = JSON.parse(result);
                this.setState({
                    allowAdminUnlockSignedNotes: data.allowAdminUnlockSignedNotes,
                    allowHealthcareProviderUnlockSignedNotes: data.allowHealthcareProviderUnlockSignedNotes,
                    // sendEmailReminderIfThereAreUnsignedNotesOlderThenAWeek: data.sendEmailReminderIfThereAreUnsignedNotesOlderThenAWeek,
                }, () => {
                    this.setState({
                        dbAllowAdminUnlockSignedNotes: data.allowAdminUnlockSignedNotes,
                        dbAllowHealthcareProviderUnlockSignedNotes: data.allowHealthcareProviderUnlockSignedNotes,
                        // dbSendEmailReminderIfThereAreUnsignedNotesOlderThenAWeek: data.sendEmailReminderIfThereAreUnsignedNotesOlderThenAWeek,
                    })
                });
            }
        });
    }

    componentDidMount() {
        this.getSettings();
    }

    updateSettings = () => {
        this.setState({
            showPlayer: true,
            _loading: true
        }, () => {
            fetch(`${API_ENDPOINT}/user/journal/settings/${this.props.selectedGroup}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('authToken')}`,
                },
                body: JSON.stringify({
                    allowAdminUnlockSignedNotes: this.state.allowAdminUnlockSignedNotes,
                    allowHealthcareProviderUnlockSignedNotes: this.state.allowHealthcareProviderUnlockSignedNotes,
                    // sendEmailReminderIfThereAreUnsignedNotesOlderThenAWeek: this.state.sendEmailReminderIfThereAreUnsignedNotesOlderThenAWeek,
                }),
            }).then(parseText).then(({ status, result }) => {
                if (status == 200) {
                    // Settings updated successfully
                }
                this.setState({
                    showPlayer: false,
                    showPlayer2: true,
                    _loading: false,
                    settingsChanged: false
                }, () => {
                    setTimeout(() => {
                        this.setState({ showPlayer2: false });
                    }, 1000);
                })

                this.props.verifyUser(() => {
                    if (this.state.changeTabIndex) {

                        this.setState({ tabIndex: this.state.tabIndexCheck, tabIndexCheck: false, changeTabIndex: null }, () => this.props.abortAction());
                    } else {
                        this.props.abortAction()
                    }
                }, () => { });

                if (this.props.changeLinkModal && this.props.changeLinkModal.indexOf('group|') != -1) {
                    this.props.changeGroup(this.props.changeLinkModal.split('|')[1])
                    this.props.abortAction()
                } else if (this.props.changeLinkModal && this.props.changeLinkModal.indexOf('clinic|') != -1) {
                    this.props.changeClinic(this.props.changeLinkModal.split('|')[1]);
                    this.props.abortAction()
                } else if (this.props.changeLinkModal) {
                    this.props[0].history.push(this.props.changeLinkModal)
                    this.props.abortAction()
                }

                this.props.abortAction()
            });
        })

    }
    stopAnimation = () => {
        this.player?.current?.play();
    };

    componentDidUpdate(prevProps, prevState) {
        if (((prevState.allowAdminUnlockSignedNotes !== this.state.allowAdminUnlockSignedNotes && this.state.dbAllowAdminUnlockSignedNotes !== this.state.allowAdminUnlockSignedNotes) || (prevState.allowHealthcareProviderUnlockSignedNotes !== this.state.allowHealthcareProviderUnlockSignedNotes && this.state.dbAllowHealthcareProviderUnlockSignedNotes !== this.state.allowHealthcareProviderUnlockSignedNotes)) && this.state.settingsChanged) {
            this.props.groupSettingsChanged()

        } else if (((prevState.allowAdminUnlockSignedNotes !== this.state.allowAdminUnlockSignedNotes) || (prevState.allowHealthcareProviderUnlockSignedNotes !== this.state.allowHealthcareProviderUnlockSignedNotes)) && this.state.settingsChanged && this.state.dbAllowAdminUnlockSignedNotes === this.state.allowAdminUnlockSignedNotes && this.state.dbAllowHealthcareProviderUnlockSignedNotes === this.state.allowHealthcareProviderUnlockSignedNotes) {
            this.props.abortAction();
            this.setState({
                tabIndexCheck: false,
                settingsChanged: false
            })
        }

        if (this.props.selectedGroup !== prevProps.selectedGroup) {
            this.getSettings();
        }
    }

    render() {

        return (
            <div className='dashboard'>
                <Container fluid>
                    <Row>
                        <Col lg={12} md={12} sm={12} xs={12}>
                            <div className='panel'>
                                <Row>
                                    <Col lg="12">
                                        <h5 className="component-header mb-35">{this.props.linksMeta && this.props.linksMeta[this.props[0].location.pathname] ? this.props.linksMeta[this.props[0].location.pathname][this.props.lang] : ''}</h5>
                                    </Col>
                                    <Col lg="12">
                                        <div className="tabs-buttons-wrap" style={{ zIndex: 950 }} >

                                            <Button className={this.state.tabIndex == 1 ? "tab-button acitve-tab-button" : "tab-button"} onClick={() => this.setState({ tabIndex: 1 })}>{"Settings".translate(this.props.lang)}</Button>
                                            <Button className={this.state.tabIndex == 2 ? "tab-button acitve-tab-button" : "tab-button"} onClick={() => this.state.settingsChanged ? this.setState({ tabIndexCheck: 2 }) : this.setState({ tabIndex: 2 })}>{"Template".translate(this.props.lang)}</Button>
                                            <Button className={this.state.tabIndex == 3 ? "tab-button acitve-tab-button" : "tab-button"} onClick={() => this.state.settingsChanged ? this.setState({ tabIndexCheck: 3 }) : this.setState({ tabIndex: 3 })}>{"QR-code".translate(this.props.lang)}</Button>
                                        </div>
                                    </Col>

                                    {
                                        this.state.tabIndex == 1 &&
                                        <Col lg={12}>
                                            <div style={{ display: 'flex', flexDirection: 'column', gap: 30 }}>
                                                <Checkbox
                                                    label={'Allow admin to unlock signed notes'.translate(this.props.lang)}
                                                    checked={this.state.allowAdminUnlockSignedNotes || false}
                                                    onChange={(e) => {
                                                        this.setState({ allowAdminUnlockSignedNotes: e.target.checked, settingsChanged: true })
                                                    }}
                                                />
                                                <Checkbox
                                                    label={'Allow healthcare provider to unlock signed notes'.translate(this.props.lang)}
                                                    checked={this.state.allowHealthcareProviderUnlockSignedNotes || false}
                                                    onChange={(e) => {
                                                        this.setState({ allowHealthcareProviderUnlockSignedNotes: e.target.checked, settingsChanged: true })
                                                    }}
                                                />
                                                {/* <Checkbox
                                                    label={'Send email reminder if there are unsigned notes older then a week'.translate(this.props.lang)}
                                                    checked={this.state.sendEmailReminderIfThereAreUnsignedNotesOlderThenAWeek || false}
                                                    onChange={(e) => {
                                                        this.setState({ sendEmailReminderIfThereAreUnsignedNotesOlderThenAWeek: e.target.checked })
                                                    }}
                                                /> */}
                                            </div>
                                            <Button type="submit" style={{ marginTop: 30 }} color="primary" disabled={this.state._loading} onClick={() => {
                                                if (!this.state._loading)
                                                    this.updateSettings()
                                            }}>
                                                {
                                                    this.state.showPlayer ? (
                                                        <Player
                                                            onEvent={(event) => {
                                                                if (event === "load") this.stopAnimation();
                                                            }}
                                                            onStateChange={this.toggleVisibility}
                                                            ref={this.player} // set the ref to your class instance
                                                            autoplay={true}
                                                            loop={true}
                                                            controls={true}
                                                            src="https://assets8.lottiefiles.com/packages/lf20_ZSRKCF.json"
                                                            style={{ height: "30px", width: "30px" }}
                                                        ></Player>

                                                    ) : this.state.showPlayer2 ? (
                                                        <div style={{ display: 'flex', alignItems: 'center' }}><Player
                                                            onStateChange={this.toggleVisibility}
                                                            ref={this.player2} // set the ref to your class instance
                                                            autoplay={true}
                                                            loop={true}
                                                            controls={true}
                                                            src="https://assets10.lottiefiles.com/packages/lf20_CxyxLk.json"
                                                            style={{ height: "30px", width: "30px" }}
                                                        ></Player>
                                                            {'Saved'.translate(this.props.lang)}
                                                        </div>
                                                    ) : (
                                                        "Save".translate(this.props.lang)
                                                    )
                                                }

                                            </Button>
                                        </Col>
                                    }
                                    {
                                        this.state.tabIndex == 2 &&
                                        <Col lg={12}>
                                            <JournalTemplatesPage {...this.props} />
                                        </Col>
                                    }
                                    {
                                        this.state.tabIndex == 3 &&
                                        <Col lg={12}>
                                            <div>
                                                <DoorQrDownload {...this.props} />
                                            </div>
                                        </Col>
                                    }
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </Container>

                {
                    this.state.tabIndexCheck ?
                        <Modal isOpen={this.state.tabIndexCheck} centered>
                            <ModalBody className="delete-modal">
                                <p className="message">{'Data is not saved, if you click Yes it will be deleted'.translate(this.props.lang)}</p>
                                <p>{this.props.isDirtySecond}</p>
                            </ModalBody>
                            <ModalFooter className='buttons-right-blue'>
                                <Button color="primary" style={{ margin: 10, minWidth: 100 }} onClick={() => {

                                    if (this.state.settingsChanged) {
                                        this.setState({
                                            changeTabIndex: true
                                        }, () => {
                                            this.updateSettings()
                                        })
                                    }


                                }}>{'Save and exit'.translate(this.props.lang)}</Button>


                                <Button color="primary" style={{ margin: 10, minWidth: 100 }} onClick={() => this.setState({ tabIndex: this.state.tabIndexCheck, tabIndexCheck: false, }, () => {

                                    this.setState({
                                        allowAdminUnlockSignedNotes: this.state.dbAllowAdminUnlockSignedNotes,
                                        allowHealthcareProviderUnlockSignedNotes: this.state.dbAllowHealthcareProviderUnlockSignedNotes,
                                        settingsChanged: false
                                    })
                                    this.props.abortAction()
                                    this.props.verifyUser(() => { })

                                })}>{'Exit without saving'.translate(this.props.lang)}</Button>

                                <Button color="primary" style={{ margin: 10, minWidth: 100 }} onClick={() => this.setState({ tabIndexCheck: false }, () => {

                                    this.props.abortAction()

                                })}>{'Go back'.translate(this.props.lang)}</Button>

                            </ModalFooter>
                        </Modal>
                        : null
                }
                {
                    this.props.changeLinkModal ?
                        <Modal isOpen={this.props.changeLinkModal} centered>
                            <ModalBody className="delete-modal">
                                <p className="message">{'Data is not saved, if you click Yes it will be deleted'.translate(this.props.lang)}</p>
                            </ModalBody>
                            <ModalFooter className='buttons-right-blue'>
                                <Button color="primary" style={{ margin: 10, minWidth: 100 }} onClick={() => {
                                    if (this.state.settingsChanged) {
                                        this.updateSettings()
                                    }


                                }}>{'Save and exit'.translate(this.props.lang)}</Button>


                                <Button color="primary" style={{ margin: 10, minWidth: 100 }} onClick={() => this.setState({ showForm: null, /*tabIndex: this.state.tabIndexCheck,*/ tabIndexCheck: false, colorSchemeChanged: false, selectedColorScheme: this.state.currentScheme, pageBuilderChanged: false, bookingSettingsChanged: false, webDocSettingsChanged: false }, () => {
                                    this.setState({
                                        showForm: true
                                    }, () => {
                                        if (this.props.changeLinkModal.indexOf('group|') != -1) {
                                            this.props.changeGroup(this.props.changeLinkModal.split('|')[1])
                                            this.props.abortAction()
                                        } else if (this.props.changeLinkModal.indexOf('clinic|') != -1) {
                                            this.props.changeClinic(this.props.changeLinkModal.split('|')[1]);
                                            this.props.abortAction()
                                        } else {
                                            this.props.verifyUser(() => {
                                                this.props[0].history.push(this.props.changeLinkModal)
                                                this.props.abortAction()
                                            })
                                        }
                                    })
                                })}>{'Exit without saving'.translate(this.props.lang)}</Button>

                                <Button color="primary" style={{ margin: 10, minWidth: 100 }} onClick={() => this.setState({ tabIndexCheck: false }, () => {
                                    this.props.abortAction()

                                })}>{'Go back'.translate(this.props.lang)}</Button>

                            </ModalFooter>
                        </Modal>
                        : null
                }
            </div >
        );
    }
}

const selector = formValueSelector('modalForm');

export default connect(state => {
    return { group: selector(state, 'group') }

}, {
    changeSubgroup: value => change("modalForm", "subgroup", value),

})(Page(JournalNotesPage));
